import { Injectable, Injector, inject } from '@angular/core';

import { TimerService } from '@frontend/sports/common/core/utils/timer';
import { DialogAnimation, ModalDialogService, ModalRef } from '@frontend/sports/modal/feature';
import { EpcotConfigService } from 'packages/sports/web/app/src/common/epcot-config.service';

import { EditMybetContainerComponent } from '../components/edit-bet-container.component';
import { EditBetUtils } from './edit-bet-utils';

@Injectable()
export class EditBetModalDialogService {
    private modalDialogRef: ModalRef | null = null;
    fadeOutClass = 'edit-my-bet-receipt__dialog--fadeout';
    slideOutFromTopToButtom = 'modal-slide-out-to-bottom';

    private injector = inject(Injector);

    constructor(
        private modalDialogService: ModalDialogService,
        private editMyBetUtils: EditBetUtils,
        private timerService: TimerService,
        private epcotConfigService: EpcotConfigService,
    ) {}

    openEditBetModal(animationType?: DialogAnimation): ModalRef {
        const epcotClass = this.epcotConfigService.isEnabled() ? 'epcot-enabled' : '';

        this.modalDialogRef = this.modalDialogService.openPopup(EditMybetContainerComponent, {
            settings: {
                cssClass: `modal-popup betslip-edit-bet__modal-window ${epcotClass}`,
                showPageHeader: true,
                fit: false,
                isModalDialog: false,
                animation: animationType,
                afterResulted: () => this.editMyBetUtils.notifyShowSliderGames(),
                injector: this.injector,
            },
        });
        this.modalDialogRef.result.catch(() => {});

        this.editMyBetUtils.notifyHideSliderGames();

        return this.modalDialogRef;
    }

    closeEditBetModal(closeWithFadeout: boolean = true): void {
        const delayForFadeOutAnimation = 500;
        if (this.modalDialogRef) {
            if (this.epcotConfigService.isEnabled()) {
                this.modalDialogRef.addWindowClass(closeWithFadeout ? this.fadeOutClass : this.slideOutFromTopToButtom);
                this.timerService.setTimeoutOutsideAngular(() => {
                    this.modalDialogRef?.dismiss();
                    this.modalDialogRef = null;
                }, delayForFadeOutAnimation);
            } else {
                this.modalDialogRef.dismiss();
                this.modalDialogRef = null;
            }
        }
    }
}
